/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetNutrientConfigQueryResponse, ArtifactsControllerGetNutrientConfigPathParams, ArtifactsControllerGetNutrientConfig400, ArtifactsControllerGetNutrientConfig404 } from "../../models/documentArtifactsController/ArtifactsControllerGetNutrientConfig";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerGetNutrientConfig } from "../../clients/document-artifactsService/artifactsControllerGetNutrientConfig";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerGetNutrientConfigQueryKey = (documentId: ArtifactsControllerGetNutrientConfigPathParams["documentId"], renditionId: ArtifactsControllerGetNutrientConfigPathParams["renditionId"], artifactId: ArtifactsControllerGetNutrientConfigPathParams["artifactId"]) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/nutrient-config',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId
  }
}] as const;
export type ArtifactsControllerGetNutrientConfigQueryKey = ReturnType<typeof artifactsControllerGetNutrientConfigQueryKey>;
export function artifactsControllerGetNutrientConfigQueryOptions(documentId: ArtifactsControllerGetNutrientConfigPathParams["documentId"], renditionId: ArtifactsControllerGetNutrientConfigPathParams["renditionId"], artifactId: ArtifactsControllerGetNutrientConfigPathParams["artifactId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerGetNutrientConfigQueryKey(documentId, renditionId, artifactId);
  return queryOptions<ArtifactsControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<ArtifactsControllerGetNutrientConfig400 | ArtifactsControllerGetNutrientConfig404>, ArtifactsControllerGetNutrientConfigQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerGetNutrientConfig(documentId, renditionId, artifactId, config);
    }
  });
}

/**
 * @description Uploads the artifact PDF to Nutrient Document Engine if needed, then returns a JWT and server URL for server-based viewing.
 * @summary Get Nutrient Document Engine config for an artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/nutrient-config}
 */
export function useArtifactsControllerGetNutrientConfig<TData = ArtifactsControllerGetNutrientConfigQueryResponse, TQueryData = ArtifactsControllerGetNutrientConfigQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerGetNutrientConfigQueryKey>(documentId: ArtifactsControllerGetNutrientConfigPathParams["documentId"], renditionId: ArtifactsControllerGetNutrientConfigPathParams["renditionId"], artifactId: ArtifactsControllerGetNutrientConfigPathParams["artifactId"], options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<ArtifactsControllerGetNutrientConfig400 | ArtifactsControllerGetNutrientConfig404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerGetNutrientConfigQueryKey(documentId, renditionId, artifactId);
  const query = useQuery({
    ...artifactsControllerGetNutrientConfigQueryOptions(documentId, renditionId, artifactId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerGetNutrientConfig400 | ArtifactsControllerGetNutrientConfig404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}